module.exports = __webpack_public_path__ + "static/limited-reward-title.77270c42.png";